import Show from '../../Show/Show';
import { COLORS } from '../../../config/designSystem/Colors';
import { View } from 'react-native';

interface CircleButtonButton {
    edge?: number;
      selected: boolean;
      colorUnselected?: string;
    }

export const CircleButton = ({ selected, edge = 20,colorUnselected=COLORS.content.accent }: CircleButtonButton) => {
  if(edge < 15) {console.warn('CircleButton: edge should be at least 15');}
  const edgeSmallOne = edge - 10;
  const borderColor = selected?COLORS.content.accent:colorUnselected;
  return(
    <View style={{
      width: edge,
      height: edge,
      borderRadius: edge/2,
      borderWidth: 2,
      borderColor: borderColor,
      justifyContent:'center',
      alignItems:'center'}}>
      <Show when={selected}>
        <View style={{
          width: edgeSmallOne,
          height: edgeSmallOne,
          borderRadius: edgeSmallOne/2,
          backgroundColor: COLORS.content.accent}}/>
      </Show>
    </View>
  );
};
